import React, { createContext, useContext, useState, useEffect } from 'react';
import { onAuthStateChanged, signInWithEmailAndPassword, signOut as firebaseSignOut } from 'firebase/auth';
import { doc, onSnapshot } from 'firebase/firestore';
import { auth, db, SYSTEM_ID } from '../lib/firebase';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authError, setAuthError] = useState('');

  const myRole = userProfile?.roles?.[SYSTEM_ID];
  const canAccess = myRole && myRole !== 'none' && myRole !== '';

  useEffect(() => {
    let unsubProfile = null;
    const unsubAuth = onAuthStateChanged(auth, (u) => {
      setUser(u);
      if (!u) {
        if (unsubProfile) unsubProfile();
        unsubProfile = null;
        setUserProfile(null);
        setLoading(false);
        return;
      }
      if (unsubProfile) unsubProfile();
      unsubProfile = onSnapshot(doc(db, 'users', u.uid), (snap) => {
        setUserProfile(snap.exists() ? { id: snap.id, ...snap.data() } : null);
        setLoading(false);
      }, (err) => {
        console.error('Erro ao carregar perfil:', err);
        setUserProfile(null);
        setLoading(false);
      });
    });
    return () => {
      unsubAuth();
      if (unsubProfile) unsubProfile();
    };
  }, []);

  const signIn = async (email, password) => {
    setAuthError('');
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      const msg = err.code === 'auth/invalid-credential' || err.code === 'auth/wrong-password'
        ? 'E-mail ou senha incorretos.'
        : err.message || 'Erro ao entrar.';
      setAuthError(msg);
      throw err;
    }
  };

  const signOut = () => firebaseSignOut(auth);

  const value = {
    user,
    userProfile,
    myRole,
    canAccess,
    loading,
    authError,
    setAuthError,
    signIn,
    signOut,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth deve ser usado dentro de AuthProvider');
  return ctx;
}
